import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=50d42e4e&scoped=true"
import script from "./ui-select.vue?vue&type=script&lang=ts"
export * from "./ui-select.vue?vue&type=script&lang=ts"
import style0 from "./ui-select.vue?vue&type=style&index=0&id=50d42e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d42e4e",
  null
  
)

export default component.exports